import React from 'react'
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'

// @material-ui/icons
import Chat from '@material-ui/icons/Chat'
import VerifiedUser from '@material-ui/icons/VerifiedUser'
import GroupOutlined from '@material-ui/icons/GroupOutlined'

// core components
import GridContainer from 'components/Grid/GridContainer.jsx'
import GridItem from 'components/Grid/GridItem.jsx'
import InfoArea from 'components/InfoArea/InfoArea.jsx'

import productStyle from 'assets/jss/material-kit-react/views/landingPageSections/productStyle.jsx'

class ProductSection extends React.Component {
    render() {
        const { classes } = this.props
        return (
            <div className={classes.section}>
                <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={8}>
                        <h2 className={classes.title}>What Can We Do?</h2>
                        <h5 className={classes.description}>
              At a glance, you can see mood trends of your patients, schedule
              appointments and meetings, and even handle accounting and payment
              processing through our cloud accounting partners. Our ongoing
              mission is to provide therapists, psychologists, and other
              behavioral health specialists every tool necessary to succeed.
                        </h5>
                    </GridItem>
                </GridContainer>
                <div>
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={4}>
                            <InfoArea
                                title="Practice Management"
                                description="Keeping track of notes, maintaining a busy schedule, and balancing the books is a lot of labor intensive work for someone who wants to help others. Luckily, we want to help you by making those things a breeze."
                                icon={Chat}
                                iconColor="info"
                                vertical
                            />
                        </GridItem>
                        <GridItem xs={12} sm={12} md={4}>
                            <InfoArea
                                title="Security At The Core"
                                description="We spent an incredible amount of effort making sure you got to this landing page completely securely. Imagine what measures we have for you and your patients' data."
                                icon={VerifiedUser}
                                iconColor="success"
                                vertical
                            />
                        </GridItem>
                        <GridItem xs={12} sm={12} md={4}>
                            <InfoArea
                                title="Always Working For Your Patients."
                                description="At its core, Resilient Vitality is much more than practice management. A mobile app for patients allows them to journal. From which, we can provide contextually relevant mindfulness activities and information and give you valuable insights into a patients state of mind."
                                icon={GroupOutlined}
                                iconColor="info"
                                vertical
                            />
                        </GridItem>
                    </GridContainer>
                </div>
            </div>
        )
    }
}

export default withStyles(productStyle)(ProductSection)



// WEBPACK FOOTER //
// ./src/views/LandingPage/Sections/ProductSection.jsx